//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/TaggedObject.js";
let d=[[],[[["channel","file"],"AddMainProgram",{R_:{program:"SIM.NcProgram"}},2,0],[["channel","fileName"],"CreateMainProgram",{R_:{program:"SIM.NcProgram"}},2,0],[["file"],"AddSubprogram",{R_:{program:"SIM.NcProgram"}},1,0],[["program"],"DeleteProgram",{R_:{success:''}},1,0],[["channel"],"GetMainProgram",{R_:{program:"SIM.NcProgram"}},1,0],[["programId"],"GetSubprogram",{R_:{program:"SIM.NcProgram"}},1,0]],[]];
SPLM.SIM.NcProgramSource = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.NcProgramSource";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;